import React from 'react'
import GoogleLogin from 'react-google-login'
import GoogleLogout from 'react-google-login'
import FontAwesome from 'react-fontawesome'
import 'font-awesome/css/font-awesome.css'

const responseGoogle = (response) => {
  console.log(response);
}

const onSuccessResponseGoogle = (response) => {
  // http://localhost:8080/gaauth/tokensignin
  // response.tokenId

  fetch('http://localhost:8080/gauth/tokensignin', {
    method: 'POST',
    headers: {
      Accept: 'application/json', 'Content-Type': 'application/json',
    },
    //body: "idtoken=" + response.tokenId,
    body: JSON.stringify({idtoken: response.tokenId}),
  }).then((response) => response.json())
  .then((responseJson) => {
    console.log("I think we got back:  " + JSON.stringify(responseJson));
  })
  .catch((error) => {
    console.error(error);
  });
}

const onLogoutSuccess = (response) => {
  console.log('Logged out!');
}

const onGetContacts = (response) => {
  console.log('Getting contacts ...');

  window.gapi.client.people.people.connections.list({
     'resourceName': 'people/me',
     'pageSize': 100,
     'personFields': 'names,emailAddresses',
   }).then(function(response) {
     console.log(JSON.stringify(response));
     var connections = response.result.connections;
     console.log('Connections:');

     if (connections.length > 0) {
       for (let i = 0; i < connections.length; i++) {
         var person = connections[i];
         if (person.names && person.names.length > 0) {
           console.log(person.names[0].displayName)
         } else {
           console.log("No display name found for connection.");
         }
       }
     } else {
       console.log('No upcoming events found.');
     }
   });
}

// className="g-signin2" data-width="300" data-height="200" data-longtitle="true"
const Profile = () => {
  return (
    <div>
      <h1>Profile</h1>
      <p><FontAwesome name="rocket"/>Some info about who you are ... and maybe some stats?  :)</p>

      <GoogleLogin
        clientid="746348471088-715be7j4k7ss681trrou2d74tlpdgkhr.apps.googleusercontent.com"
        className="g-signin2" data-width="300" data-height="200" data-longtitle="true"
        discoveryDocs="https://www.googleapis.com/discovery/v1/apis/people/v1/rest"
        scope="https://www.googleapis.com/auth/contacts.readonly"
        onSuccess={onSuccessResponseGoogle}
        onFailure={responseGoogle}
      >
        <span> Login with Google</span>
      </GoogleLogin>
      <br/>
      <br/>
      <GoogleLogout
        buttonText="Logout"
        onLogoutSuccess={onLogoutSuccess}
      >
      </GoogleLogout>
      <br/>
      <br/>
      <button onClick={onGetContacts}>Get Contacts</button>
    </div>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/containers/Profile.js